<app-progress-bar-overlay></app-progress-bar-overlay>

<ng-container>
  <div class="titolo-subtitolo">
    <div class="titolo-sezione-dialog">Selezione Cartelle per AI</div>
    <div class="descrizione-sezione-dialog">
      I documenti contenuti nelle cartelle selezionate diventeranno la fonte di conoscenza dell'IA.
    </div>
  </div>
</ng-container>

<div class="container-wrapper">
  <div class="left-container">
    <div class="titolo-container" style="border-top-left-radius: 10px">
      <div class="titolo-sezione-dialog">Elenco cartelle</div>
    </div>
    <div class="cnt-folders">
      <div class="scroll-viewport">
        <ng-container [ngTemplateOutlet]="foldersCheckbox"></ng-container>
      </div>
    </div>
  </div>

  <div class="right-container">
    <div class="titolo-container" style="border-top-right-radius: 10px">
      <div class="titolo-sezione-dialog">Anteprima documenti</div>
    </div>
    <div class="cnt-card-files">
      <div class="scroll-viewport">
        <div class="cnt-card">
          <!-- F I L E S -->
          <div class="file-grid">
            @for (file of listaFiles(); track $index) {
              <app-file-card-documenti [file]="file" [isModulo]="true"></app-file-card-documenti>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  @if (!isDisable) {
    <div>
      <button mat-flat-button color="primary" (click)="salva()" class="primary-button">
        Salva
      </button>
    </div>
  }
</div>

<ng-template #foldersCheckbox>
  <div class="cnt-tree-file">
    <mat-tree
      #tree
      [dataSource]="folders()"
      [childrenAccessor]="childrenAccessor"
      [trackBy]="trackById"
    >
      <!-- NODO GENERICO -->
      <ng-container>
        <mat-tree-node
          *matTreeNodeDef="let folder; when: hasSottoCartelle"
          matTreeNodePadding
          [matTreeNodePaddingIndent]="24"
        >
          <div class="cnt-tree-node">
            <!-- ICONA ESPANSIONE -->
            <mat-icon
              class="arrow-icon"
              [ngStyle]="{ color: hasSottoCartelle(folder) ? '#1f1f1f' : 'transparent' }"
              (click)="expandCollapseFolder(folder); $event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()"
            >
              {{ tree.isExpanded(folder) ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
            </mat-icon>

            <!-- CHECKBOX -->
            <mat-checkbox
              [class.checkbox-primary]="getChecked(folder)"
              [class.checkbox-accent]="getIndeterminate(folder)"
              [disabled]="isDisable"
              [checked]="getChecked(folder)"
              [indeterminate]="getIndeterminate(folder)"
              (change)="toggleFolder(folder, $event.checked)"
              (click)="$event.stopPropagation()"
              (keydown.enter)="$event.stopPropagation()"
            ></mat-checkbox>

            <!-- ICONA CARTELLA + NOME -->
            <div class="cnt-icon-nome-folder">
              <mat-icon>{{ folderIcon(folder) }}</mat-icon>
              <span class="nome-folder">{{ folder.name }}</span>
              <span class="nr-files">({{ folder.files.length }})</span>
            </div>
          </div>
        </mat-tree-node>
      </ng-container>
    </mat-tree>
  </div>
</ng-template>
